export default function ProfTestTimerBar({ formatted, remainingSeconds, totalSeconds }) {
    if (!formatted) return null;
    const urgent = remainingSeconds != null && remainingSeconds <= 60;
    const ratio =
        totalSeconds > 0 && remainingSeconds != null
            ? Math.max(0, Math.min(1, remainingSeconds / totalSeconds))
            : 1;

    return (
        <div
            className={`sticky top-0 z-20 border-b backdrop-blur-xl ${
                urgent ? "border-rose-200 bg-rose-50/95" : "border-violet-100 bg-white/90"
            }`}
            data-testid="prof-timer"
        >
            <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-3">
                <div className="flex items-center gap-2.5">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-full ${urgent ? "bg-rose-100 text-rose-700" : "bg-violet-100 text-violet-700"}`} aria-hidden="true">
                        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l2.5 1.5M12 3a9 9 0 110 18 9 9 0 010-18z" />
                        </svg>
                    </span>
                    <span className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
                        Осталось времени
                    </span>
                </div>
                <span className={`font-mono text-lg font-bold tabular-nums ${urgent ? "text-rose-700" : "text-violet-800"}`}>
                    {formatted}
                </span>
            </div>
            <div className="h-1 bg-slate-100">
                <div
                    className={`h-full transition-[width] duration-300 ${
                        urgent ? "bg-rose-500" : "bg-violet-600"
                    }`}
                    style={{ width: `${ratio * 100}%` }}
                />
            </div>
        </div>
    );
}
